export const photoCropperConstant = {
    PLACEHOLDER_DEFAULT: 'Drag and drop or click here',
    CROPPER_DEFAULT_TITLE: 'Edit Photo',
    ROTATE: 'Rotate',
    CHOOSE_ANOTHER_PHOTO: 'CHOOSE ANOTHER PHOTO',
    UPLOAD: 'UPLOAD',
    OK: 'Done',
};

export const newFileFromDataURI = (dataURI) => {
    return new File([dataURI], 'new_file', { type: 'image' });
};
